<template>
  <div class="columns is-vcentered has-background-white is-multiline is-gapless is-padding-top-xsmall is-padding-bottom-xsmall is-padding-right-xsmall">
    <div
      class="column is-12 columns is-gapless is-marginless"
      :class="[canDrag ? '' : 'is-padding-left-xsmall']">
      <div
        v-if="canDrag"
        class="column is-narrow is-w50p"></div>
      <div class="column">
        <r-label
          :is-required="false"
          :label="'Nom du fichier'"
          :for-id="'documentFileName-' + document.path"></r-label>
      </div>
    </div>
    <div
      class="column is-narrow is-w50p has-cursor-grab has-text-centered"
      v-if="canDrag">
      <i class="fal fa-grip-lines"></i>
    </div>
    <div
      class="column is-padding-top-xxsmall"
      :class="[canDrag ? '' : 'is-padding-left-xsmall']">
      <div class="field has-addons">
        <p class="control is-expanded">
          <v-input
            :id="'documentFileName-' + document.path"
            :name="'documentFileName-' + document.path"
            :model="filename"
            :errors-bag="errors"
            :from-flux="fromFlux"
            :disabled="!canEdit"
            data-vv-value-path="val"
            data-vv-as="Nom du fichier"
            label=""
            :classes="''"
            v-validate="'required|min:2'"
            @input="val => updateName(val)">
          </v-input>
        </p>
        <div
          class="is-padding-right is-padding-left is-flex is-align-items-center has-background-grey-lightest has-text-grey is-italic">
          .{{ extensionName }}
        </div>
        <p
          class="control"
          v-if="canEdit && editName && !askDelete">
          <a
            class="button is-square is-success"
            @click="updateDocument">
            <span class="is-small"><i class="fal fa-save"></i></span>
          </a>
        </p>
        <p
          class="control"
          v-if="!askDelete">
          <a
            class="button is-square is-grey is-inverted is-border tooltip"
            :href="document.path"
            target="_blank"
            :download="getFilename"
            data-tooltip="Télécharger">
            <i class="fal fa-download"></i>
          </a>
        </p>
        <p
          class="control"
          v-if="canEdit && !askDelete">
          <a
            class="button is-square is-grey is-inverted is-border"
            @click="askDelete = true">
            <i class="fal fa-trash-alt"></i></a>
        </p>
      </div>
    </div>
    <div
      v-if="editDisplayEnabled && !askDelete"
      class="column is-narrow is-w150p is-padding-left-xsmall is-padding-top-xxsmall">
      <input
        :id="'document_display-' + index + document.path"
        type="checkbox"
        :name="'document_display-' + index + document.path"
        class="switch is-success is-rounded"
        v-model="displayDoc"
        @input="updateDisplay">
      <label :for="'document_display-' + index + document.path">
        <span class="is-size-6 has-text-grey">{{ displayDoc ? 'Visible par tous' : 'Masqué' }}</span>
      </label>
    </div>

    <div
      class="column is-narrow is-padding-left-xsmall is-padding-top-xxsmall"
      v-if="askDelete">
      <div class="field has-addons">
        <div class="control">
          <a
            @click="deleteDocument"
            class="button is-small is-danger">
            <span>Confirmer suppression</span>
          </a>
        </div>
        <div class="control">
          <a
            @click="askDelete = false"
            class="button is-small is-white is-border is-square ">
            <span class="icon is-small">
              <i class="fas fa-times is-size-5"></i>
            </span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ViewFileItem',
  props: {
    document: {
      type: Object,
      default: () => {}
    },
    canDrag: {
      type: Boolean,
      default: true
    },
    index: {
      type: Number,
      default: 0
    },
    fromFlux: {
      type: Boolean,
      default: false
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    editDisplayEnabled: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      editName: false,
      askDelete: false,
      displayDoc: false,
      filename: '',
      extensionName: 'Null'
    }
  },
  computed: {
    /**
       * file name
       * @returns {string}
       */
    getFilename () {
      if (this.document.name) {
        return this.document.name
      } else {
        return this.document.filename
      }
    }
  },
  async created () {
    await this.addDestination()
    if (this.document && 'destination' in this.document && this.document.destination) {
      this.displayDoc = this.document.destination.includes('display_in_adv')
    }
    if (this.document.name) {
      this.parseNameExtension(this.document.name)
    } else {
      this.parseNameExtension(this.document.filename)
    }
  },
  methods: {
    /**
       * add destination to document
       */
    addDestination () {
      if (!('destination' in this.document) || !this.document.destination) {
        this.$set(this.document, 'destination', ['display_in_adv'])
      }
    },
    /**
       * update name
       * @param {string} val -document name
       */
    updateName (val) {
      this.editName = true
      this.filename = val
      if (this.document.hasOwnProperty('name')) {
        this.document.name = this.filename + '.' + this.extensionName
      } else {
        this.document.filename = this.filename + '.' + this.extensionName
      }
    },
    /**
       * update display
       */
    updateDisplay () {
      this.displayDoc = !this.displayDoc
      if (this.displayDoc) {
        this.document.destination.push('display_in_adv')
      } else {
        this.document.destination = this.document.destination.filter(x => x !== 'display_in_adv')
      }
      this.updateDocument()
    },
    /**
       * emit update document
       */
    updateDocument () {
      this.editName = false
      this.$emit('update', { document: this.document, index: this.index })
    },
    /**
       * emit delete document
       */
    deleteDocument () {
      this.askDelete = false
      this.$emit('delete', { index: this.index })
    },
    parseNameExtension (string) {
      let tab = string.split('.')
      if (tab.length > 1) {
        this.extensionName = tab.pop()
        tab.splice(tab.length, 1)
        this.filename = tab.join('.')
      } else {
        this.filename = tab.join('.')
      }
    }

  }
}
</script>
